<!--
 * @Author: wangxb 18254141586@163.com
 * @Date: 2023-11-24 10:30:58
 * @LastEditors: wangxb 18254141586@163.com
 * @LastEditTime: 2023-12-11 17:08:50
 * @FilePath: \ui-jfgjgl-v2\src\views\dataBoard\index.vue
 * @Description:
-->
<template>
  <div class="container">
    <div class="data-board-header">
      <div class="header-box">
        <div class="header-box__item">
          <div class="item-datetime">
            <div class="time">{{dateClock.time}}</div>
            <div class="date">{{dateClock.date}}</div>
          </div>
          <div class="item-week">{{dateClock.week}}</div>
          <div class="item-form item-select">
            <div class="item-form__label">
              <img src="../../assets/img/dataBoard/icon-project.png" />
            </div>
            <div class="item-form__body">
              <el-select v-model="boardType"
                         :popper-append-to-body="false"
                         popper-class="custom-select-popper-class"
                         class="custom-header-input"
                         size="small"
                         placeholder="请选择"
                         @change="handleChangeBoardType">
                <el-option v-for="item in boardOptions"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item-tabs"
               v-if="boardType==='project'">
            <div class="item-tabs__item"
                 :class="{active:activeTab==='overall'}"
                 @click="handleClickTab('overall')">
              迄今总体维度
            </div>
            <div class="item-tabs__item"
                 :class="{active:activeTab==='month'}"
                 @click="handleClickTab('month')">
              月报维度
            </div>
          </div>
        </div>
        <div class="header-box__item">
          <div class="item-form item-select">
            <div class="item-form__label">
              <img src="../../assets/img/dataBoard/icon-dept.png" />
            </div>
            <div class="item-form__body">
              <el-select v-model="formParams.deptId"
                         :popper-append-to-body="false"
                         popper-class="custom-select-popper-class"
                         class="custom-header-input"
                         size="small"
                         @change="handleChangeDept"
                         placeholder="请选择">
                <el-option v-for="item in deptList"
                           :key="item.DEPTID"
                           :label="item.DEPTNAME"
                           :value="item.DEPTID">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item-form item-date-range">
            <div class="item-form__form">
              <img src="../../assets/img/dataBoard/icon-calendar.png" />
            </div>
            <div class="item-form__body">
              <el-date-picker v-show="!(boardType==='project' && activeTab ==='month')"
                              v-model="formParams.dateRangeArr"
                              class="custom-header-input"
                              size="small"
                              type="daterange"
                              popper-class="custom-date-popper-class"
                              value-format="yyyy-MM-dd"
                              :unlink-panels="true"
                              range-separator="~"
                              :append-to-body="false"
                              @change="handleChangeDateRangeForOut"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期">
              </el-date-picker>
              <el-date-picker v-show="boardType==='project' && activeTab ==='month'"
                              v-model="formParams.monthDate"
                              class="custom-header-input"
                              size="small"
                              type="month"
                              popper-class="custom-date-popper-class"
                              format="yyyy 年 MM 月"
                              value-format="yyyy-MM"
                              @change="handleChangeMonth"
                              :append-to-body="false"
                              placeholder="选择月">
              </el-date-picker>
            </div>
          </div>
          <div class="item-more"
               @click.stop="handleShowDialogForm">
            <div class="item-more__label">
              <img src="../../assets/img/dataBoard/icon-more-down.png" />
            </div>
            <div class="item-more__content">更多</div>
          </div>
        </div>
      </div>
      <div class="search-box"
           v-clickoutside="handleCloseSearchBox"
           v-show="showSeachBox">
        <el-form ref="form"
                 size="small"
                 :model="dialogForm"
                 label-width="125px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="项目名称：">
                <el-input v-model="dialogForm.projectName"
                          placeholder="请输入项目名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="项目负责人：">
                <el-input v-model="dialogForm.projectLeader"
                          placeholder="请输入项目负责人"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="项目自定义编号：">
                <el-input v-model="dialogForm.projectCustomCode"
                          placeholder="请输入项目自定义编号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="项目类型：">
                <el-select v-model="dialogForm.projectType" :popper-append-to-body="false"
                  popper-class="custom-select-popper-class" class="custom-header-input" size="small"
                  @change="handleChangeProjectType" placeholder="请选择">
                  <el-option v-for="item in projectTypeList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="项目自定义类型：">
                <el-select v-model="dialogForm.projectCustomType" :popper-append-to-body="false"
                  popper-class="custom-select-popper-class" class="custom-header-input" size="small"
                  @change="handleChangeProjectCustomType" placeholder="请选择">
                  <el-option v-for="item in projectCustomTypeList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="项目划型：">
                <el-select v-model="dialogForm.projectClassification" :popper-append-to-body="false"
                  popper-class="custom-select-popper-class" class="custom-header-input" size="small"
                  @change="handleChangeprojectClassification" placeholder="请选择">
                  <el-option v-for="item in projectClassificationList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6"
                    v-show="boardType==='project' && activeTab === 'month'">
              <el-form-item label="项目开始时间：">
                <el-date-picker v-model="dialogForm.dateRangeArr"
                                class="custom-header-input"
                                size="small"
                                type="daterange"
                                popper-class="custom-date-popper-class"
                                value-format="yyyy-MM-dd"
                                :unlink-panels="true"
                                range-separator="~"
                                :append-to-body="false"
                                @change="handleChangeDateRangeForDialog"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6"
                    v-show="boardType !== 'project'">
              <el-form-item label="合同自定义类型：">
                <el-cascader v-model="dialogForm.customType"
                             :options="contractCustomTypeList"
                             popper-class="custom-cascader-popper-class"
                             :append-to-body="false"
                             :props="{ expandTrigger: 'hover' }"
                             @change="handleChangeContractCustomType"
                             placeholder="请选择"></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="priceRangeLabel">
                <div class="price-range">
                  <div class="price-range__item">
                    <el-input v-model="dialogForm.minAmount"
                              placeholder="请输入最小值"></el-input>
                  </div>
                  <div class="price-range__delive">~</div>
                  <div class="price-range__item">
                    <el-input v-model="dialogForm.maxAmount"
                              placeholder="请输入最大值"></el-input>
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="6"
                    v-show="boardType!=='project'">
              <el-form-item label="合同名称：">
                <el-input v-model="dialogForm.contractName"
                          placeholder="请输入合同名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6"  v-show="boardType !== 'project'">
              <el-form-item label="合同自定义类别">
                <el-select v-model="dialogForm.contractCustomCategoryCodes" :popper-append-to-body="false"
                  popper-class="custom-select-popper-class" class="custom-header-input" size="small"
                  @change="handleChangeContractCustomCategory" placeholder="请选择">
                  <el-option v-for="item in contractCustomCategoryList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6"  v-show="boardType !== 'project'">
              <el-form-item label="合同类别">
                <el-select v-model="dialogForm.contractCategoryCode" :popper-append-to-body="false"
                  popper-class="custom-select-popper-class" class="custom-header-input" size="small"
                  @change="handleChangeContractCategory" placeholder="请选择">
                  <el-option v-for="item in contractCategoryList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20"
                  v-show="boardType!=='collection'">
            <el-form-item label="标签："
                          class="tag-checkbox">
              <el-checkbox-group v-model="dialogForm.labelIds">
                <el-col :span="3"
                        v-for="item in counterParatyTags"
                        :key="item.COUNTERPARTY_TAGS_ID">
                  <el-checkbox :label="item.COUNTERPARTY_TAGS_ID"
                               name="type">
                    {{item.TAG_INFO}}</el-checkbox>
                </el-col>
              </el-checkbox-group>
            </el-form-item>
          </el-row>
        </el-form>
        <div class="search-box__tools">
          <div class="tools-btn"
               @click="handleFilter">筛选</div>
          <div class="tools-btn"
               @click="handleResetDialogForm">重置</div>
        </div>
      </div>
    </div>
    <div class="data-board-content">
      <project-overall ref="projectOverall"
                       v-if="boardType==='project' && activeTab==='overall'"></project-overall>
      <project-month ref="projectMonth"
                     v-if="boardType==='project' && activeTab==='month'"></project-month>
      <income-contract ref="incomeContract"
                       v-if="boardType==='income_contract'"></income-contract>
      <expend-contract ref="expendContract"
                       v-if="boardType==='expend_contract'"></expend-contract>
      <collection ref="collection"
                  v-if="boardType==='collection'"></collection>
      <cash ref="cash"
                  v-if="boardType==='cash'"></cash>
    </div>
    <div class="v-modal"
         @touchmove.prevent
         @wheel.prevent.stop
         tabindex="0"
         style="z-index: 990;"
         v-show="showMask"></div>
  </div>
</template>

<script>
import projectOverall from './components/project/overall.vue'
import projectMonth from './components/project/month.vue'
import incomeContract from './components/contract/income.vue'
import expendContract from './components/contract/expend.vue'
import collection from './components/collection/index.vue'
import cash from './components/cash/index.vue'
import { getList, getDict } from '@/api/common/jeUtils'
import dayjs from 'dayjs'
import weekday from 'dayjs/plugin/weekday'
import updateLocale from 'dayjs/plugin/updateLocale'
import 'dayjs/locale/zh-cn'
dayjs.extend(weekday)
dayjs.extend(updateLocale)
dayjs.locale('zh-cn')
dayjs.updateLocale('zh-cn', {
  weekdaysShort: ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
})
export default {
  components: {
    projectOverall,
    projectMonth,
    incomeContract,
    expendContract,
    collection,
    cash
  },
  data() {
    return {
      dateClock: {
        time: '',
        date: '',
        week: ''
      },
      boardOptions: [
        {
          value: 'project',
          label: '项目数据'
        }, {
          value: 'income_contract',
          label: '收入合同数据'
        }, {
          value: 'expend_contract',
          label: '支出合同数据'
        }, {
          value: 'collection',
          label: '回款数据'
        }, {
          value: 'cash',
          label: '现金流数据'
        }
      ],
      boardType: 'project',
      // overall:迄今总体维度;month:月份维度
      activeTab: 'overall',
      priceRangeLabel: '项目金额：',
      // 部门列表
      deptList: [],
      formParams: {
        deptId: '',
        deptIds: [],
        dateRangeArr: [],
        startDate: '',
        endDate: '',
        monthDate: '',
        labelIds: [],
        customType: [''],
        contractCustomTypeIds: [],
        contractName: '',
        maxAmount: '',
        minAmount: '',
        projectLeader: '',
        projectName: '',
        projectCustomCode: '',
        projectType: '',
        projectCustomType: '',
        projectClassification: '',
        contractCustomCategoryCodes: '',
        contractCategoryCode: ''
      },
      dialogForm: {
        dateRangeArr: [],
        startDate: '',
        endDate: '',
        labelIds: [],
        customType: [''],
        contractCustomTypeIds: [],
        contractName: '',
        maxAmount: '',
        minAmount: '',
        projectLeader: '',
        projectName: '',
        projectCustomCode: '',
        projectType: '',
        projectCustomType: '',
        projectClassification: '',
        contractCustomCategoryCodes: '',
        contractCategoryCode: ''
      },
      // 标签
      counterParatyTags: [],
      showSeachBox: false,
      showMask: false,
      // 合同自定义类型
      contractCustomTypeList: [],
      // 项目类型
      projectTypeList: [],
      // 项目自定义类型
      projectCustomTypeList: [],
      // 项目划型
      projectClassificationList: [],
      // 合同自定义类别
      contractCustomCategoryList: [],
      // 合同类别
      contractCategoryList: []

    }
  },
  mounted() {
    this.handleChangeBoardType(this.boardType)
    // 时间定时器
    this.timeFn()
    // 加载部门
    this.loadDept()
    // 加载相对方标签
    this.loadCounterParatyTags()
    // 加载自定义合同类型
    this.loadContractCustomType()
    // 加载项目类型
    this.loadProjectType()
    // 加载项目自定义类型
    this.loadProjectCustomType()
    // 加载项目划型
    this.loadProjectClassification()
    // 合同自定义类别
    this.loadContractCustomCategoryList()
    // 合同类别
    this.loadCcontractCategoryList()
    // 初始化搜索条件以及让对应的组件加载内容
    this.initPage()
  },
  methods: {
    /**
     * @Description: 初始化页面搜索条件以及让对应组件展示并加载内容
     * @return {*}
     */
    initPage() {
      const startDate = dayjs('2021-01-01').format('YYYY-MM-DD')
      const endDate = dayjs().format('YYYY-MM-DD')
      const monthDate = dayjs().format('YYYY-MM')
      // 初始化搜索条件
      this.formParams = {
        deptId: '',
        deptIds: [],
        dateRangeArr: [startDate, endDate],
        startDate,
        endDate,
        monthDate,
        labelIds: [],
        customType: [''],
        contractCustomTypeIds: [],
        contractName: '',
        maxAmount: '',
        minAmount: '',
        projectLeader: '',
        projectName: '',
        projectCustomCode: '',
        projectType: '',
        projectCustomType: '',
        projectClassification: '',
        contractCustomCategoryCodes: '',
        contractCategoryCode: ''
      }
      this.loadComponentsData()
    },
    /**
     * @Description: 定时器=>时钟设置
     */
    timeFn() {
      setInterval(() => {
        const now = new Date()
        this.dateClock.time = dayjs(now).format('HH:mm:ss')
        this.dateClock.date = dayjs(now).format('YYYY.MM.DD')
        this.dateClock.week = dayjs(now).format('ddd')
      }, 1000)
    },
    /**
     * @Description: 切换标签
     * @param {*} tabsName
     */
    handleClickTab(tabsName) {
      if (tabsName !== this.activeTab) {
        this.activeTab = tabsName
        this.initPage()
      }
    },
    /**
     * @Description: 切换不同的看板
     * @param {*} value
     */
    handleChangeBoardType(value) {
      if (value === 'project') {
        this.priceRangeLabel = '项目金额：'
        this.activeTab = 'overall'
      } else if (value === 'collection') {
        this.priceRangeLabel = '回款金额：'
      } else {
        this.priceRangeLabel = '合同金额：'
      }
      // 根据不同的标签初始化搜索条件
      this.initPage()
    },
    /**
     * @Description: 加载部门信息
     */
    loadDept() {
      getList({
        tableCode: 'JE_CORE_DEPARTMENT',
        j_query: JSON.stringify([
          { type: '=', code: 'STATUS', value: '1', cn: 'and' },
          { type: '=', code: 'LAYER', value: '2', cn: 'and' }
        ]),
        limit: -1
      }).then(res => {
        if (res.success) {
          const list = res.rows
          list.unshift({
            DEPTNAME: '全部部门',
            DEPTID: ''
          })
          this.deptList = res.rows
        }
      })
    },
    /**
     * @Description: 加载相对方标签
     * @return {*}
     */
    loadCounterParatyTags() {
      getList({
        tableCode: 'COUNTERPARTY_TAGS',
        j_query: JSON.stringify([
          { type: '=', code: 'SY_STATUS', value: '1', cn: 'and' }
        ]),
        limit: -1
      }).then(res => {
        if (res.success) {
          this.counterParatyTags = res.rows
        }
      })
    },
    /**
     * @Description: 加载合同自定义类型
     */
    loadContractCustomType() {
      getList({
        tableCode: 'CONTRACT_CUSTOM_TYPE',
        j_query: JSON.stringify([
          { type: '=', code: 'SY_STATUS', value: '1', cn: 'and' }
        ]),
        limit: -1
      }).then(res => {
        if (res.success) {
          const { rows } = res
          const list = [{
            label: '全部',
            value: ''
          }]
          for (const item of rows) {
            const contractTypeCode = item.CONTRACT_TYPE_CODE
            const idx = list.findIndex(i => i.value === contractTypeCode)
            const obj = {
              value: item.CONTRACT_CUSTOM_TYPE_ID,
              label: item.CUSTOM_TYPE
            }
            if (idx !== -1) {
              list[idx].children.push(obj)
            } else {
              const parentObj = {
                value: contractTypeCode,
                label: item.CONTRACT_TYPE_NAME,
                children: [obj]
              }
              list.push(parentObj)
            }
          }
          this.contractCustomTypeList = list
        }
      })
    },
    /**
     * @Description:加载项目自定义类型
     */
    loadProjectType() {
      getDict({
        dictCode: 'APPROVAL_PROJECT_TYPE'
      }).then(res => {
        if (res.success) {
          const rt = res.obj
          const list = [{
            label: '全部',
            value: ''
          }]
          for (const item of rt) {
            const obj = {
              value: item.code,
              label: item.text
            }
            list.push(obj)
          }
          this.projectTypeList = list
        }
      })
    },
    /**
     * @Description: 加载项目自定义类型
     */
    loadProjectCustomType() {
      getDict({
        dictCode: 'RECORD_PROJECT_TYPE'
      }).then(res => {
        if (res.success) {
          const rt = res.obj
          const list = [{
            label: '全部',
            value: ''
          }]
          for (const item of rt) {
            const obj = {
              value: item.code,
              label: item.text
            }
            list.push(obj)
          }
          this.projectCustomTypeList = list
        }
      })
    },
    /**
     * @Description: 加载项目自定义类型
     */
    loadProjectClassification() {
      getDict({
        dictCode: 'PROJECT_CLASSIFICATION'
      }).then(res => {
        if (res.success) {
          const rt = res.obj
          const list = [{
            label: '全部',
            value: ''
          }]
          for (const item of rt) {
            const obj = {
              value: item.code,
              label: item.text
            }
            list.push(obj)
          }
          this.projectClassificationList = list
        }
      })
    },
    /**
    * @Description: 合同自定义类别
    */
    loadContractCustomCategoryList() {
      getDict({
        dictCode: 'CONTRACT_CUSTOM_CATEGORY'
      }).then(res => {
        if (res.success) {
          const rt = res.obj
          const list = [{
            label: '全部',
            value: ''
          }]
          for (const item of rt) {
            const obj = {
              value: item.code,
              label: item.text
            }
            list.push(obj)
          }
          this.contractCustomCategoryList = list
        }
      })
    },
    /**
     * @Description: 合同类别
     */
    loadCcontractCategoryList() {
      getDict({
        dictCode: 'CONTRACT_CATEGORY'
      }).then(res => {
        if (res.success) {
          const rt = res.obj
          const list = [{
            label: '全部',
            value: ''
          }]
          for (const item of rt) {
            const obj = {
              value: item.code,
              label: item.text
            }
            list.push(obj)
          }
          this.contractCategoryList = list
        }
      })
    },
    /**
     * @Description: 弹出筛选表单
     */
    handleShowDialogForm() {
      this.showSeachBox = !this.showSeachBox
      this.showMask = !this.showMask
      // 将formParams中的值赋予到dialogForm中
      this.dialogForm.dateRangeArr = this.formParams.dateRangeArr
      this.dialogForm.startDate = this.formParams.startDate
      this.dialogForm.endDate = this.formParams.endDate
      this.dialogForm.labelIds = this.formParams.labelIds
      this.dialogForm.contractCustomTypeIds = this.formParams.contractCustomTypeIds
      this.dialogForm.maxAmount = this.formParams.maxAmount
      this.dialogForm.minAmount = this.formParams.minAmount
      this.dialogForm.projectLeader = this.formParams.projectLeader
      this.dialogForm.projectName = this.formParams.projectName
      this.dialogForm.contractName = this.formParams.contractName
      this.dialogForm.projectCustomCode = this.formParams.projectCustomCode
      this.dialogForm.projectType = this.formParams.projectType
      this.dialogForm.projectCustomType = this.formParams.projectCustomType
      this.dialogForm.projectClassification = this.formParams.projectClassification
      this.dialogForm.contractCustomCategoryCodes = this.formParams.contractCustomCategoryCodes
      this.dialogForm.contractCategoryCode = this.formParams.contractCategoryCode
    },
    /**
     * @Description: 点击其他地方关闭查询弹窗
     */
    handleCloseSearchBox() {
      if (this.showSeachBox) {
        this.showSeachBox = !this.showSeachBox
        this.showMask = !this.showMask
      }
    },
    /**
     * @Description: 重置弹出表单
     */
    handleResetDialogForm() {
      this.dialogForm = {
        dateRangeArr: [],
        startDate: '',
        endDate: '',
        labelIds: [],
        customType: [''],
        contractCustomTypeIds: [],
        contractName: '',
        maxAmount: '',
        minAmount: '',
        projectLeader: '',
        projectName: '',
        projectCustomCode: '',
        projectType: '',
        projectCustomType: '',
        projectClassification: '',
        contractCustomCategoryCodes: '',
        contractCategoryCode: ''
      }
      if (this.boardType === 'project' && this.activeTab === 'month') {
        const startDate = dayjs('2021-01-01').format('YYYY-MM-DD')
        const endDate = dayjs().format('YYYY-MM-DD')
        this.dialogForm.dateRangeArr = [startDate, endDate]
        this.dialogForm.startDate = startDate
        this.dialogForm.endDate = endDate
      }
      // 执行搜索事件
      this.handleFilter()
    },
    /**
     * @Description: 执行筛选操作
     */
    handleFilter() {
      // 将ddialogForm中的值赋予给formParams
      this.formParams.dateRangeArr = this.dialogForm.dateRangeArr
      this.formParams.startDate = this.dialogForm.startDate
      this.formParams.endDate = this.dialogForm.endDate
      this.formParams.labelIds = this.dialogForm.labelIds
      this.formParams.contractCustomTypeIds = this.dialogForm.contractCustomTypeIds
      this.formParams.maxAmount = this.dialogForm.maxAmount ? parseFloat(this.dialogForm.maxAmount) : ''
      this.formParams.minAmount = this.dialogForm.minAmount ? parseFloat(this.dialogForm.minAmount) : ''
      this.formParams.projectLeader = this.dialogForm.projectLeader
      this.formParams.projectName = this.dialogForm.projectName
      this.formParams.contractName = this.dialogForm.contractName
      this.formParams.projectCustomCode = this.dialogForm.projectCustomCode
      this.formParams.projectType = this.dialogForm.projectType
      this.formParams.projectCustomType = this.dialogForm.projectCustomType
      this.formParams.projectClassification = this.dialogForm.projectClassification
      this.formParams.contractCustomCategoryCodes = this.dialogForm.contractCustomCategoryCodes
      this.formParams.contractCategoryCode = this.dialogForm.contractCategoryCode
      if (this.boardType === 'project' && this.activeTab === 'month') {
        const monthDate = dayjs().format('YYYY-MM')
        this.formParams.monthDate = monthDate
      }
      // 执行关闭弹窗事件
      this.handleCloseSearchBox()
      // 重新加载组件内容
      this.loadComponentsData()
    },
    /**
     * @Description: 加载组件内容
     */
    loadComponentsData() {
      switch (this.boardType) {
        case 'collection':
          this.$nextTick(() => {
            this.$refs.collection.initPage(this.formParams)
          })
          break
        case 'expend_contract':
          this.$nextTick(() => {
            this.$refs.expendContract.initPage(this.formParams)
          })
          break
        case 'income_contract':
          this.$nextTick(() => {
            this.$refs.incomeContract.initPage(this.formParams)
          })
          break
        case 'project': {
          if (this.activeTab === 'overall') {
            this.$nextTick(() => {
              this.$refs.projectOverall.initPage(this.formParams)
            })
          } else {
            this.$nextTick(() => {
              this.$refs.projectMonth.initPage(this.formParams)
            })
          }

          break
        }
        case 'cash':
          this.$nextTick(() => {
            this.$refs.cash.initPage(this.formParams)
          })
          break
        default:
          break
      }
    },
    /**
     * @Description: 切换部门
     * @param {*} deptId
     */
    handleChangeDept(deptId) {
      if (deptId !== '') {
        this.formParams.deptIds = [deptId]
      } else {
        this.formParams.deptIds = []
      }
      this.loadComponentsData()
    },
    /**
     * @Description: 时间改变
     * @param {*} value
     */
    handleChangeDateRangeForOut(value) {
      this.formParams.startDate = value[0]
      this.formParams.endDate = value[1]
      this.loadComponentsData()
    },
    /**
     * @Description: 弹出表单中时间改变
     * @param {*} value
     */
    handleChangeDateRangeForDialog(value) {
      this.dialogForm.startDate = value[0]
      this.dialogForm.endDate = value[1]
    },
    /**
     * @Description: 合同自定义类型修改
     * @param {*} value
     */
    handleChangeContractCustomType(value) {
      const customTypeId = value.at(-1)
      if (customTypeId !== '') {
        this.dialogForm.contractCustomTypeIds = [customTypeId]
      } else {
        this.dialogForm.contractCustomTypeIds = []
      }
    },
    /**
     * @Description: 改变项目类型
     *  @param {*} value
     */
    handleChangeProjectType(value) {
      const projectType = value
      if (projectType !== '') {
        this.dialogForm.projectType = projectType
      } else {
        this.dialogForm.projectType = ''
      }
    },
    /**
     * @Description: 改变项目自定义类型
     *  @param {*} value
     */
    handleChangeProjectCustomType(value) {
      const projectcustomType = value
      if (projectcustomType !== '') {
        this.dialogForm.projectcustomType = projectcustomType
      } else {
        this.dialogForm.projectcustomType = ''
      }
    },
    /**
     * @Description: 改变项目划型
     *  @param {*} value
     */
    handleChangeprojectClassification(value) {
      const projectClassification = value
      if (projectClassification !== '') {
        this.dialogForm.projectClassification = projectClassification
      } else {
        this.dialogForm.projectClassification = ''
      }
    },
    /**
     * @Description: 改变合同自定义类别
     *  @param {*} value
     */
    handleChangeContractCustomCategory(value) {
      const contractCustomCategoryCode = value
      if (contractCustomCategoryCode !== '') {
        this.dialogForm.contractCustomCategoryCodes = contractCustomCategoryCode
      } else {
        this.dialogForm.contractCustomCategoryCodes = ''
      }
    },
    /**
     * @Description: 改变合同类别
     *  @param {*} value
     */
    handleChangeContractCategory(value) {
      const contractCategoryCode = value
      if (contractCategoryCode !== '') {
        this.dialogForm.contractCategoryCode = contractCategoryCode
      } else {
        this.dialogForm.contractCategoryCode = ''
      }
    },
    /**
     * @Description: 月份改变
     * @return {*}
     */
    handleChangeMonth() {
      this.loadComponentsData()
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  min-width: 1910px;
  min-height: 100vh;
  background: #090f14;
}
.data-board-header {
  max-width: 1920px;
  height: 7.9rem;
  margin: 0 auto;
  background-image: url("../../assets/img/dataBoard/bg-header.png");
  background-position-y: -2.8rem;
  background-color: #090f14;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;

  // 顶部通栏内容
  .header-box {
    position: absolute;
    width: 100%;
    height: 4.5rem;
    bottom: 0;
    display: flex;
    min-width: 0;
    align-items: center;
    justify-content: space-between;
    padding: 0 1.6rem;
    &__item {
      height: 100%;
      min-width: 0;
      display: flex;
      align-items: center;
      // 时间
      .item-datetime {
        color: #fff;
        text-align: right;
        padding: 0 1rem 0 0;
        position: relative;

        &::after {
          content: " ";
          position: absolute;
          width: 0.1rem;
          background: #939191;
          height: 2.5rem;
          top: 25%;
          right: 0;
        }

        .time {
          font-size: 2rem;
          line-height: 2.5rem;
          height: 2.5rem;
        }

        .date {
          font-size: 1.2rem;
          color: #939191;
          height: 2rem;
        }
      }
      // 星期
      .item-week {
        color: #fff;
        padding: 0 1rem;
        font-size: 1.7rem;
        font-weight: 500;
      }

      // tab切换
      .item-tabs {
        display: flex;
        align-items: center;
        height: 3.2rem;
        &__item {
          font-size: 1.7rem;
          line-height: 3.2rem;
          height: 3.2rem;
          background-color: transparent;
          padding-left: 1.7rem;
          color: #477eae;
          font-style: oblique;
          background-repeat: no-repeat;
          background-size: cover;
          cursor: pointer;

          &.active {
            color: #fff;
            text-shadow: -1px 1px 3px rgba(0, 0, 0, 0.5),
              3px 2px rgba(255, 255, 255, 0.3);
          }

          &:first-child {
            background-image: url("../../assets/img/dataBoard/tab-first-bg.png");
            width: 15rem;

            &.active {
              background-image: url("../../assets/img/dataBoard/tab-first-active-bg.png");
            }
          }

          &:last-child {
            background-image: url("../../assets/img/dataBoard/tab-last-bg.png");
            width: 11.5rem;
            &.active {
              background-image: url("../../assets/img/dataBoard/tab-last-active-bg.png");
            }
          }
        }
      }

      // 表单内容-下拉框/时间范围选择/时间选择通用css
      .item-form {
        display: flex;
        align-items: center;
        min-width: 0;
        height: 3.2rem;
        &__label {
          width: 2.4rem;
          display: flex;
          align-items: center;

          img {
            width: 100%;
            height: auto;
          }
        }

        &__body {
          flex: 1;
          min-width: 0;
          margin-left: 0.3rem;

          .custom-header-input {
            width: 97%;
            height: 100%;
          }

          /deep/ .el-input--small {
            font-size: 1.7rem;
            color: #fff;
            .el-input__inner {
              line-height: 3.2rem;
              height: 3.2rem;
              background-color: transparent;
              border: none;
              padding-left: 0.3rem;
              color: #fff;
              font-style: oblique;
              text-shadow: -1px 1px 3px rgba(0, 0, 0, 0.5),
                3px 2px rgba(255, 255, 255, 0.3);
            }

            &.el-date-editor--month {
              .el-input__inner {
                text-align: center;
              }
            }
          }

          /deep/ .el-date-editor {
            background-color: transparent;
            border: none;
            .el-input__icon {
              display: none;
            }
            .el-range-separator {
              font-size: 1.7rem;
              color: #fff;
              font-style: oblique;
              text-shadow: -1px 1px 3px rgba(0, 0, 0, 0.5),
                3px 2px rgba(255, 255, 255, 0.3);
              width: 10%;
            }

            .el-range-input {
              font-size: 1.7rem;
              color: #fff;
              line-height: 3.2rem;
              height: 3.2rem;
              background-color: transparent;
              border: none;
              font-style: oblique;
              text-shadow: -1px 1px 3px rgba(0, 0, 0, 0.5),
                3px 2px rgba(255, 255, 255, 0.3);
              width: 43%;

              &::placeholder {
                font-size: 1.7rem;
                color: #fff;
                line-height: 3.2rem;
                height: 3.2rem;
                background-color: transparent;
                border: none;
                font-style: oblique;
                text-shadow: -1px 1px 3px rgba(0, 0, 0, 0.5),
                  3px 2px rgba(255, 255, 255, 0.3);
              }
            }
          }
        }
      }
      // 下拉框
      .item-select {
        width: 17.9rem;
        background-image: url("../../assets/img/dataBoard/select-bg.png");
        background-repeat: no-repeat;
      }

      // 时间范围
      .item-date-range {
        width: 29.9rem;
        background-image: url("../../assets/img/dataBoard/date-range-bg.png");
        background-repeat: no-repeat;
        margin-left: 1.6rem;
      }
      // 更多
      .item-more {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 0;
        height: 3.2rem;
        width: 10.8rem;
        background-image: url("../../assets/img/dataBoard/bg-more.png");
        background-repeat: no-repeat;
        cursor: pointer;

        &__label {
          width: 1.8rem;
          display: flex;
          align-items: center;

          img {
            width: 100%;
            height: auto;
          }
        }

        &__content {
          color: #fff;
          font-size: 1.7rem;
          margin-left: 0.8rem;
        }
      }
    }
  }

  // 弹出搜索框
  .search-box {
    position: absolute;
    width: 97%;
    bottom: -30.5rem;
    background: #090f14;
    z-index: 999;
    border: 1px solid #2b7cb5;
    margin: 0 auto;
    left: 2.5rem;
    padding: 1rem;
    height: 30.5rem;

    /deep/ .el-form {
      .el-form-item__label {
        color: #fff;
      }

      .el-input__inner {
        background: #090f14;
        border-color: #2b7cb5;
        color: #fff;
      }
    }

    .tag-checkbox {
      /deep/ .el-form-item__content {
        height: 13.5rem;
        overflow: hidden;
        overflow-y: scroll;
      }
    }

    /deep/ .el-checkbox {
      color: #fff;

      &.is-checked {
        .el-checkbox__label {
          color: #2b7cb5;
        }
      }

      .el-checkbox__input {
        &.is-checked {
          .el-checkbox__inner {
            background: #2b7cb5;
            border-color: #2b7cb5;
          }
        }
      }
      &__inner {
        border-radius: 0;
        background: transparent;
      }
    }

    .price-range {
      display: flex;
      &__item {
        flex: 1;
        align-items: center;
      }

      &__delive {
        width: 20px;
        text-align: center;
        color: #fff;
      }
    }

    /deep/ .el-date-editor {
      background-color: #090f14;
      border-color: #2b7cb5;
      .el-input__icon {
        display: none;
      }
      .el-range-separator {
        font-size: 1.7rem;
        color: #fff;
        width: 10%;
      }

      .el-range-input {
        background-color: transparent;
        border: none;
        color: #fff;
        width: 43%;
      }
    }

    &__tools {
      width: 100%;
      text-align: center;
      .tools-btn {
        display: inline-block;
        background-image: url("../../assets/img/dataBoard/btn-bg.png");
        width: 9.8rem;
        height: 2.8rem;
        color: #fff;
        text-align: center;
        font-size: 1.6rem;
        line-height: 2.8rem;
        cursor: pointer;
      }
    }
  }
}

.data-board-content {
  max-width: 1920px;
  margin: 0 auto;
}

/deep/ .custom-select-popper-class {
  background-color: #090f14;
  border: 1px solid #2e4972;

  .el-select-dropdown__item {
    color: #477eae;
    &.hover {
      color: #fff;
      background: #477eae;
    }
  }

  .selected {
    color: #fff;
    background: #477eae;
  }

  .popper__arrow {
    border-bottom-color: #477eae;
    &::after {
      border-bottom-color: #477eae;
    }
  }
}

/deep/ .custom-date-popper-class {
  background-color: #090f14;
  border: 1px solid #2e4972;
  color: #fff;

  .el-date-picker__header {
    border-color: #477eae;
    &-label {
      color: #fff;
    }
  }

  .el-picker-panel__icon-btn {
    color: #fff;

    &:hover {
      color: #477eae;
    }

    &.is-disabled {
      color: #090f14;
    }
  }

  .el-date-table {
    th {
      color: #fff;
      border-bottom-color: #477eae;
    }

    td.available:hover {
      color: #477eae;
    }

    td.in-range div {
      background: #477eae;
    }

    td.in-range:hover {
      color: #fff;
    }

    td.today {
      span {
        color: #1dfbd1;
      }
    }
  }

  .el-month-table {
    .cell {
      color: #fff;
    }

    .current,
    .today {
      .cell {
        color: #477eae;
      }
    }

    .disabled {
      .cell {
        background-color: #939191;
      }
    }
  }

  .el-year-table {
    .cell {
      color: #fff;
    }

    .current,
    .today {
      .cell {
        color: #477eae;
      }
    }
  }

  .el-date-table td.end-date span,
  .el-date-table td.start-date span {
    background-color: #2e4972;
  }

  .el-date-range-picker__content.is-left {
    border-right-color: #477eae;
  }

  .popper__arrow {
    border-bottom-color: #477eae;
    &::after {
      border-bottom-color: #477eae;
    }
  }
}

/deep/ .custom-cascader-popper-class {
  background-color: #090f14;
  border: 1px solid #2e4972;

  .el-cascader-menu {
    color: #fff;
    border-right-color: #2e4972;
  }

  .el-cascader-node {
    &:hover {
      color: #fff;
      background: #477eae;
    }
    &__label {
      color: #fff;
    }

    &.is-active {
      color: #2b7cb5;

      .el-cascader-node__label {
        color: #2b7cb5;
      }
    }

    &.in-active-path {
      .el-cascader-node__label {
        color: #2b7cb5;
      }
    }
  }

  .el-cascader-node:not(.is-disabled):focus,
  .el-cascader-node:not(.is-disabled):hover {
    color: #fff !important;
    background-color: #477eae;
    .el-cascader-node__label {
      color: #fff;
    }
  }

  .el-cascader-node.in-active-path,
  .el-cascader-node.is-active,
  .el-cascader-node.is-selectable.in-checked-path {
    color: #2b7cb5;
  }
}
</style>
